import { createSlice } from "@reduxjs/toolkit";

const surveyAnswersSlice = createSlice({
  name: "surveyAnswers",
  initialState: {},
  reducers: {
    addSurveyAnswers(state, action) {
      return Object.assign({}, state, action.payload);
    },
  },
});

export const { addSurveyAnswers } = surveyAnswersSlice.actions;

export default surveyAnswersSlice.reducer;
